<template>
	<div class="instruction-item tw-p-4 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-4">
			<span class="title"><b>{{ item.name }}</b></span>
		</div>
		<p-horizontal-divider mx="-1rem" my="1rem" />
		<section class="tw-flex">
			<v-select
				class="select-core"
				hide-details
				label="Carreras requeridas para el puesto"
				chips
				clearable
				outline
				single-line
				tab-index="7"
				tags
				v-model="careerReturn[index]"
				@input="setCareer($event)"
				>
					<template slot="selection" slot-scope="data">
						<v-chip
							class="tag-chip"
							close
							@input="removeItem(data.item, index)">
							{{ data.item }}
						</v-chip>
					</template>
				</v-select>
		</section>
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';

function created() {
}

function setCareer(careers) {
	this.$emit('career-select', careers);
}

function removeItem(item, indexI) {
	const index = this.careerReturn[indexI].indexOf(item);
	if (index > -1) {
		this.careerReturn[indexI].splice(index, 1);
	}
}

export default {
	name: 'InstructionItem',
	created,
	props: ['item', 'careerReturn', 'index'],
	components: { PButton, PHorizontalDivider },
	methods: {
		setCareer,
		removeItem,
	},
};
</script>

<style lang="scss">
.instruction-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
	.title {
		color: map-get($colors, gray-sidebar);
		font-size: 16px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/fourth-step/instruction-item.vue